import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Card, Col, Row, Space, Typography, Select, Popover, Spin, Form, Button } from 'antd';
import { Pie } from '@ant-design/plots/es/';
import StatisticCard from '../common/statisticCard';
import { CalendarOutlined, CloseCircleOutlined, FilterOutlined, PauseCircleOutlined, WarningOutlined } from '@ant-design/icons';
import { getLstYearsDB, UserActivity } from '../../config/BVConstants';
import { useDispatch, useSelector } from 'react-redux';
import { getCancelCounts, getDasboardStats, getOnHoldCounts, getScheduledCount, getScheduledRiskCount } from '../../services/certificateService';
import commonService from '../../services/CommonService';
import { getClientList } from '../../utils/commonUtil';
import { setBrandNamesWithIAProjects } from '../../context/reducers/userReducer';
const PieChart = () => {
    const [dasboardStats, setDasboardStats] = useState([]);
    const [scheduledCount, setScheduledCount] = useState(0);
    const [onRiskCount, setOnRiskCount] = useState(0);
    const [onHoldCount, setOnHoldCount] = useState(0);
    const [cancelledCount, setCancelledCount] = useState(0);
    const [loading, setLoading] = useState(true); // Loader state
    const applicationData = useSelector((state) => state.applicationData);
    const brandOptions = applicationData.brandNamesWithIAProjects || [];
    const yearOptions = getLstYearsDB;
    const additionalOption = { intId: 0, strLongDesc: 'All' };
    const updatedBrandOptions = [additionalOption, ...brandOptions];
    const [filteredArtifactsData, setFilteredArtifactsData] = useState([]);
    const [brandId, setBrandId] = useState(0);
    const [year, setYear] = useState(0);
    const [popoverVisible, setPopoverVisible] = useState(false);
    const [isFilterLoading, setIsFilterLoading] = useState(false);
    const dispatch = useDispatch();
    const artifactReqObj = {
        lstClientMaster: getClientList(applicationData),
        boolProjectSearch: true,
        intYear: year,
        intProjectType: 1,
        objLuBrandName: {
            intId: brandId
        }
    };
    const config = {
        data: [
            { type: `In-Progress/On Schedule (${scheduledCount})`, value: scheduledCount },
            { type: `On Hold (${onHoldCount})`, value: onHoldCount },
            { type: `In-Progress/On Risk (${onRiskCount})`, value: onRiskCount },
            { type: `Cancelled (${cancelledCount})`, value: cancelledCount }
        ],
        angleField: 'value',
        colorField: 'type',
        paddingRight: 40,
        innerRadius: 0.6,
        legend: {
            color: {
                title: true,
                position: 'top',
                rowPadding: 5
            }
        }
    };
    useEffect(() => {
        commonService.getBrandNamesWithIAProjects(applicationData === null || applicationData === void 0 ? void 0 : applicationData.selClientList).then((res) => {
            dispatch(setBrandNamesWithIAProjects(res));
        });
    }, [applicationData === null || applicationData === void 0 ? void 0 : applicationData.selClientList]);
    useEffect(() => {
        setDasboardStats(getDasboardStats(scheduledCount, _jsx(CalendarOutlined, {}), onRiskCount, _jsx(WarningOutlined, {}), onHoldCount, _jsx(PauseCircleOutlined, {}), cancelledCount, _jsx(CloseCircleOutlined, {})));
    }, [scheduledCount, onRiskCount, onHoldCount, cancelledCount]);
    useEffect(() => {
        commonService.searchAllProjects(artifactReqObj).then((res) => {
            var _a, _b;
            updateStatsCounts(res);
            setLoading(false);
            commonService
                .logUserActivity((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmailId, UserActivity.CP__Dashboard_All_Proj_Search);
        });
    }, [isFilterLoading]);
    const updateStatsCounts = (data) => {
        setScheduledCount(getScheduledCount(data));
        setOnRiskCount(getScheduledRiskCount(data));
        setOnHoldCount(getOnHoldCounts(data));
        setCancelledCount(getCancelCounts(data));
        setFilteredArtifactsData(data);
    };
    const handleApply = () => {
        setIsFilterLoading(!isFilterLoading);
        setPopoverVisible(false);
    };
    const popoverContent = (_jsxs(Form, { style: { width: '300px' }, children: ["Brand:", _jsx(Form.Item, { style: { margin: '0px' }, children: _jsx(Select, { placeholder: "Select Brand", onChange: (value) => {
                        setBrandId(updatedBrandOptions[value].intId);
                    }, style: { width: '100%' }, size: "small", title: "Brand", children: Object.entries(updatedBrandOptions).map(([value, label]) => (_jsx(Select.Option, { value: value, children: label === null || label === void 0 ? void 0 : label.strLongDesc }, value))) }) }), "Year:", _jsx(Form.Item, { style: { margin: '0px' }, children: _jsx(Select, { placeholder: "Select Year", onChange: (value) => setYear(parseInt(value)), style: { width: '100%', height: 24 }, children: Object.entries(yearOptions).map(([value, label]) => (_jsx(Select.Option, { value: value, children: label }, value))) }) }), _jsx(Form.Item, { style: { margin: '0px', textAlign: 'end' }, children: _jsx(Button, { onClick: handleApply, htmlType: "submit", type: "primary", children: "Apply" }) })] }));
    const filterControls = (_jsx(Popover, { content: popoverContent, trigger: "click", open: popoverVisible, onOpenChange: setPopoverVisible, getPopupContainer: (trigger) => document.body, placement: "bottomRight", style: { zIndex: 900 }, children: _jsx(FilterOutlined, {}) }));
    return (_jsx(Row, { gutter: [16, 16], children: _jsx(Col, { xs: 24, sm: 24, md: 24, lg: 24, xl: 24, children: _jsx(Card, { className: "dashboard-card", size: "small", title: "All Projects", extra: filterControls, children: _jsxs(Row, { children: [_jsx(Col, { xs: 24, sm: 24, md: 24, lg: 24, xl: 24, children: _jsx(Space, { size: "small", direction: "vertical", style: { width: '100%', textAlign: 'center' }, children: _jsx("div", { style: { height: '431px' }, children: loading ? (_jsxs("div", { style: {
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            height: '478px'
                                        }, children: [' ', _jsx(Spin, { size: "small" })] })) : (_jsx(_Fragment, { children: filteredArtifactsData.length === 0 ? (_jsx("div", { children: _jsx("center", { children: "No data found" }) })) : (_jsx(Pie, Object.assign({}, config))) })) }) }) }), _jsx(Col, { xs: 24, sm: 24, md: 24, lg: 24, xl: 24, children: _jsx(Row, { gutter: [16, 16], children: dasboardStats &&
                                    dasboardStats.map((item, index) => (_jsx(Col, { xs: 24, sm: 12, md: 6, children: _jsx(StatisticCard, { title: item === null || item === void 0 ? void 0 : item.title, value: item === null || item === void 0 ? void 0 : item.value, icon: item === null || item === void 0 ? void 0 : item.icon, color: index === 0
                                                ? 'rgb(23, 131, 255)'
                                                : index === 1
                                                    ? 'rgb(0, 201, 201)'
                                                    : index === 2
                                                        ? 'rgb(240, 136, 77)'
                                                        : 'rgb(213, 128, 255)', index: index, keys: item === null || item === void 0 ? void 0 : item.keys, R: item === null || item === void 0 ? void 0 : item.R, B: brandId, Y: year }) }, index))) }) }), _jsx(Col, { xs: 24, sm: 24, md: 24, lg: 24, xl: 24, style: { textAlign: 'center' }, children: _jsx(Typography.Text, { style: { fontSize: '10px' }, children: "Note: Completed Projects are not shown in this chart" }) })] }) }) }) }));
};
export default PieChart;
